import { render, staticRenderFns } from "./AdminForumInfo.vue?vue&type=template&id=3e3f6807&scoped=true&"
import script from "./AdminForumInfo.vue?vue&type=script&lang=js&"
export * from "./AdminForumInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdminForumInfo.vue?vue&type=style&index=0&id=3e3f6807&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3f6807",
  null
  
)

export default component.exports